import React from 'react';
import { select } from 'd3';
import Map from '../lib/Map';
import MAPDATA from '../data/CanadaProvTopo.json';

export default class CanadaMap extends React.Component {
  componentDidMount() {
    this.map = new Map(this.svg);
    this.map.setData(MAPDATA);
    this.map.drawMap();
    this.map.onProvClickCallback = () => {
      this.props.onProvSelect(this.map.activeProvs);
    }
    this.map.selectUniqueProvince('Alberta');
  }

  render() {
    return (
      <div className="mapContainer">
        <svg
          ref={svg => this.svg = select(svg)}>
        </svg>
      </div>
    );
  }
}